<app-confirm-pop-up-finzy-flex-skeleton>
    <div content [innerHTML] = 'popUpData.message'></div>
</app-confirm-pop-up-finzy-flex-skeleton>
